import { useEffect, useState } from "react";
import palletIcon from "assets/images/pallet-icon-loader.png";
import "./PalletLoader.css";

const FACTS = [
  "75% of purchase decisions are made at the point of sale.",
  "Retailers using real-time inventory see 30% fewer stockouts.",
  "Self-checkout kiosks can reduce queue times by up to 40%.",
  "Top-performing stores process 1,000+ transactions per terminal daily.",
  "Mobile POS increases sales-floor coverage by up to 50%.",
  "Personalised promotions at checkout lift basket size by 20% on average.",
];

// Splash shows for 4 000 ms — rotate a fact every 1 300 ms
const FACT_INTERVAL = 1300;

export default function PalletLoader() {
  const [factIdx, setFactIdx] = useState(0);
  const [fadeIn, setFadeIn] = useState(true);

  useEffect(() => {
    const id = setInterval(() => {
      setFadeIn(false);
      setTimeout(() => {
        setFactIdx((i) => (i + 1) % FACTS.length);
        setFadeIn(true);
      }, 280);
    }, FACT_INTERVAL);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="pl-screen">
      <div className="pl-body">
        {/* Icon */}
        <div className="pl-icon-wrap">
          <img src={palletIcon} alt="Pallet" className="pl-icon" />
        </div>

        {/* Rotating fact */}
        <p className={`pl-fact${fadeIn ? " pl-fact--in" : " pl-fact--out"}`}>
          {FACTS[factIdx]}
        </p>
      </div>

      {/* Progress bar anchored to the bottom */}
      <div className="pl-bar-track">
        <div className="pl-bar-fill" />
      </div>
    </div>
  );
}
